import { Font, StyleSheet } from '@react-pdf/renderer';
Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'WeIconFont',
  src: '/we-icons.ttf',
});

export const styles = StyleSheet.create({
  page: {
    paddingBottom: 40,
  },

  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
    textAlign: 'left',
  },

  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 60,
  },

  lineBar: {
    width: 160,
    marginLeft: 53,
    marginRight: 53,
  },

  bodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },

  dayHeader: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 900,

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    borderRadius: 2,

    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  day: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 900,
  },
  dateRest: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
  },

  sessionWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    marginBottom: 10,
  },

  sessionLeftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,

    width: 109,
  },
  sessionRightColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,

    flex: 1,
  },

  text: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
  },

  dayWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingTop: 10,
  },
  sessionHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    width: '100%',
    paddingTop: 10,
  },

  sessionTimeWrapper: {
    border: '1px solid black',
    borderRadius: 2,
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  sessionTimeText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
  },

  sessionLocationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 5,

    border: '1px solid black',
    borderRadius: 2,

    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  sessionLocationIcon: {
    width: 12,
    height: 12,
    objectFit: 'contain',
    color: 'white',
  },
  sessionLocationText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
    flex: 1,
  },

  sessionTitleWrapper: {
    border: '1px solid black',
    borderRadius: 2,

    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  sessionTitle: {
    color: '#27343D',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 800,
  },

  sessionDescriptionWrapper: {
    border: '1px solid black',
    borderRadius: 2,

    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  sessionDescription: {
    color: '#27343D',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
  },

  icon: {
    color: 'white',
    fontFamily: 'WeIconFont',
    fontSize: 10,
  },

  speakerName: {
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 900,
    color: '#27343D',
  },
  speakerDetails: {
    color: '#27343D',
    fontFamily: 'Lato',
    fontSize: 6,
    fontWeight: 400,
  },

  imagesWrapper: {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',

    marginTop: 40,
  },
  colImage: {
    width: '25%',
    height: 69,
    objectFit: 'cover',
  },

  buttonWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-56, -10)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    borderRadius: 2,
    paddingVertical: 5,

    width: 112,
  },
  linkText: {
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 9,
    textDecoration: 'none',
  },

  furtherInformationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginTop: 5,
  },
  furtherInformationLink: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 6,
    textDecoration: 'none',
  },
});
